import { render, staticRenderFns } from "./StartupEdit.vue?vue&type=template&id=010e4ef1&scoped=true"
import script from "./StartupEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./StartupEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e4ef1",
  null
  
)

export default component.exports